export default "__VITE_ASSET__Du02JwSH__"